import Vue from "vue";

Vue.filter("defaultLevel", (value) => {
  if (!value) return 1;
  return value;
});

Vue.filter("defaultValue", (value) => {
  if (!value) return "-";
  return value;
});
